import React from 'react';
import { 
  Droplets, 
  Flame, 
  Settings, 
  CheckCircle, 
  ArrowRight, // Added missing import
  MessageCircle, 
  X, 
  Phone, 
  Mail, 
  MapPin 
} from 'lucide-react';

// Imports for your other components
import About from '../Component/About.js';
import Herosection from '../Component/Herosection.js';
import WhyChooseUs from '../Component/Whychooseus.js';
import Testimonials from '../Component/Testimonials.js';
import CallToAction from '../Component/CallToAction.js';
import ContactSection from '../Component/ContactSection.js';
import FAQ from '../Component/Faq.js';
import Footer from '../Component/Footer.js'; // Assuming you have a footer

const brandBlue = '#004e6e';
const brandRed = '#ff4a4a';

const LandingPage = () => {
  
  // Data for the Services Section
  const services = [
    {
      title: "Sanitär",
      number: "01",
      icon: <Droplets size={40} />,
      desc: "Badneubau, Sanierung, Wasserleitungen und schnelle Hilfe bei Rohrbrüchen.",
      color: brandBlue,
      accent: brandRed,
      features: ["Badumbau & Planung", "Leitungsinstallationen", "Reparaturen"]
    },
    {
      title: "Heizung",
      number: "02",
      icon: <Flame size={40} />,
      desc: "Energieeffiziente Heizungssysteme, Wärmepumpen und nachhaltige Klimatechnik.",
      color: brandRed,
      accent: brandBlue,
      features: ["Heizungswartung", "Wärmepumpen Installation", "Boiler-Entkalkung"]
    },
    {
      title: "Wartung & Service",
      number: "03",
      icon: <Settings size={40} />,
      desc: "Verlässlicher Service für die Langlebigkeit Ihrer Anlagen. Wir sind da, wenn Sie uns brauchen.",
      color: brandBlue,
      accent: brandRed,
      features: ["Regelmäßige Kontrollen", "Rohrreinigung", "Schnelle Hilfe"]
    }
  ];

  return (
    <div className="relative min-h-screen bg-white font-sans text-gray-900">
      
      {/* 1. HERO */}
      <Herosection />

      {/* 2. ABOUT */}
      <About />

      {/* 3. EXPERTISE / SERVICES */}
      <section id="services" className="relative py-24 bg-gray-50/50 overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-6">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                  <span className="w-12 h-[2px]" style={{ backgroundColor: brandRed }}></span>
                  <span className="text-xs font-black uppercase tracking-[0.3em]" style={{ color: brandRed }}>Unsere Expertise</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black leading-tight" style={{ color: brandBlue }}>
                Massgeschneiderte Lösungen <br/> für Ihre Haustechnik.
              </h2>
            </div>
            <p className="text-gray-500 text-lg max-w-sm">
              Von der ersten Beratung bis zur regelmäßigen Wartung – wir begleiten Sie fachmännisch.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid lg:grid-cols-3 gap-10">
            {services.map((s, idx) => (
              <div 
                key={idx}
                className="group relative bg-white p-10 rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.03)] hover:shadow-[0_40px_80px_rgba(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-3 overflow-hidden border border-gray-100"
              >
                {/* Background Number */}
                <span className="absolute -top-4 -right-4 text-9xl font-black text-gray-50 opacity-[0.03] group-hover:opacity-[0.08] transition-opacity duration-500 pointer-events-none">
                  {s.number}
                </span>

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-8 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3 shadow-lg bg-white"
                     style={{ color: s.color, boxShadow: `0 10px 30px -10px ${s.color}44` }}>
                  {s.icon}
                </div>

                <h3 className="text-2xl font-black mb-4 text-gray-900 group-hover:text-[#ff4a4a] transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="text-gray-600 mb-8 leading-relaxed">
                  {s.desc}
                </p>

                {/* List */}
                <ul className="space-y-4 mb-10">
                  {s.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3 text-sm font-bold text-gray-700">
                      <CheckCircle size={18} style={{ color: s.accent }} />
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Link Action */}
                <div className="flex items-center gap-2 font-black text-xs uppercase tracking-widest transition-all duration-300 transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100" style={{ color: s.color }}>
                  Mehr Details <ArrowRight size={16} />
                </div>

                {/* Bottom Bar */}
                <div className="absolute bottom-0 left-0 h-1.5 w-0 group-hover:w-full transition-all duration-700"
                     style={{ backgroundColor: s.color }}></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. OTHER SECTIONS */}
      <WhyChooseUs />
      <Testimonials />
      <CallToAction />
      <ContactSection />
      <FAQ />
      
      {/* 5. FOOTER */}

    </div>
  );
};

export default LandingPage;